@for (hint of hintsWithEnabled(); track hint.hint.id; let i = $index) {
  <ion-button
    (click)="openClueQuestionModal(i)"
    [disabled]="!hint.enabled"
    color="warning"
    fill="outline"
  >
    <ion-icon name="bulb" slot="start" />
    Hint {{ i + 1 }}
  </ion-button>
}
